import React, { useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import "../styles/notification.scss";
const Notifications = () => {

  return (
    <>

      <Row className="notifications">
        <Col sm={12} className="notificationstitle">
          <h4>Notification<span>Mark all as read</span></h4>
        </Col>
        <Col sm={12} className="notificationslist">
          <div className="notificationmaindiv">
            <div className="profile">
              <p className="profilenames">JN</p>
            </div>
            <div className="lefts">
              <h6><span>Gnanaprakasam</span> has successfully onboarded as a admin user</h6>
              <p>30 Apr 2023, 11:49 am</p>
            </div>
            <div className="rights">
              <p>11:49 am</p>
              <p className="dots"></p>
            </div>
          </div>
        </Col>
      </Row>

    </>
  );
};
export default Notifications;